var CurrentUser = require("lib/account/CurrentUser");
var NotificationContainer = require("components/notifications/NotificationContainer");
var PendingTaskNotice = require("components/layout/PendingTaskNotice");
var L2eSound = require("components/utility/L2eSound")

var PaywallModal = require("components/users/teachers/PaywallModal");
var ResponseModal = require("components/writing/responses/ResponseModal");

var UISelectors = require("lib/selectors/UISelectors");
var UIActions = require("lib/actions/UIActions");
var RosterActions = require("lib/actions/RosterActions");

require("layout/universal_controls.scss");

import { connect } from "react-redux";
@connect(
	(state, props) => ({
		expandedResponseID: UISelectors.expandedResponseID({ state }),
		showPaywall: UISelectors.showPaywall({ state }),
	}),
	(dispatch, props) => ({
		resetExpandedResponse: () => dispatch(UIActions.toggleExpandedResponse({ responseID: null, expanded: false })),
		resetPaywall: () => dispatch(UIActions.showPaywall({ paywall: null })),
		bustRosterCache: () => dispatch(RosterActions.invalidateStudentListCache({}))
	})
)
class UniversalControls extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	componentDidUpdate(prevProps) {
		// This hacky and not a great way to do this at all
		if (this.props.expandedResponseID && !prevProps.expandedResponseID) {
			setTimeout(() => {
				this.refs.responseModal.show();				
			}, 50);
		}
	}

	render() {
		if (CurrentUser.isSignedIn() && CurrentUser.isTeacherAdmin()) {
			var feedbackEmail = "teacherfeedback@whooosreading.org";
			var feedbackBanner = (<div className="feedbackBar">
					<a className="feedbackEmail" href="https://whooosreading.zendesk.com/hc/en-us/requests/new"
						target="_blank">
						Have feedback for us?
					</a>
				</div>);
		} else if (CurrentUser.isSponsor()) {
			var feedbackBanner = (
				<div className="feedbackBar">
					<a className="feedbackEmail" href="https://whooosreading.zendesk.com/hc/en-us/requests/new"
						target="_blank">
						Have feedback for us?
					</a>
				</div>
			);
		}

		var responseID = this.props.expandedResponseID;
		if (responseID) {
			var responseModal = (
				<ResponseModal ref="responseModal" responseID={ responseID }
					onHide={ this.props.resetExpandedResponse } key={ responseID } />
			);
		}

		var showPaywall = this.props.showPaywall;
		if (showPaywall) {
			var paywallModal = (
				<PaywallModal selfOpen onHide={ this.props.resetPaywall }
					featureType={ showPaywall } key={ showPaywall } /> 
			);
		}

		return (
			<div id="universalControls">
				<L2eSound />
				<NotificationContainer />
				<PendingTaskNotice />
				{ responseModal }
				{ paywallModal }
			</div>
		)
	}

	componentDidMount() {
		$(document).on("current-user-updated", function() {
			this.forceUpdate()
		}.bind(this));
	}
};

UniversalControls.propTypes = StrictPropTypes({
	expandedResponseID: PropTypes.number,
	showPaywall: PropTypes.string,
	resetExpandedResponse: PropTypes.func,
	bustRosterCache: PropTypes.func
});

module.exports = UniversalControls;


// WEBPACK FOOTER //
// ./modules/components/layout/UniversalControls.js